import { render, staticRenderFns } from "./tax-table.vue?vue&type=template&id=dd875e98&"
import script from "./tax-table.vue?vue&type=script&lang=js&"
export * from "./tax-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports